import * as React from 'react';
import Typography, { TypographyProps }  from '@mui/material/Typography';

export interface ITextProps extends TypographyProps{
    bold?: boolean;
}

const Text = (props: ITextProps) => {
    const {bold, ...rest} = props;
    const fw = bold ? {fontWeight: 'bold'} : null;
    return <Typography style={fw} variant="body1" component="p" {...rest} />
}

export default Text;